export const USER_ID_SET = 'at/userProfile/cptAssignmentList/USER_ID_SET'
export const PANEL_TAB_SET = 'at/userProfile/cptAssignmentList/PANEL_TAB_SET'
export const TASK_IDS_SET = 'at/userProfile/cptAssignmentList/TASK_IDS_SET'
export const PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/PROJECT_IDS_SET'
export const CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/CUSTOMER_IDS_SET'
export const MANAGE_TASK_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_TASK_IDS_SET'
export const MANAGE_PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_PROJECT_IDS_SET'
export const MANAGE_CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_CUSTOMER_IDS_SET'
export const MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET'
export const MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET'
export const TASK_TAB_LOADED = 'at/userProfile/cptAssignmentList/TASK_TAB_LOADED'
export const PROJECT_TAB_LOADED = 'at/userProfile/cptAssignmentList/PROJECT_TAB_LOADED'
export const CUSTOMER_TAB_LOADED = 'at/userProfile/cptAssignmentList/CUSTOMER_TAB_LOADED'
export const USER_COUNTERS_SET = 'at/userProfile/cptAssignmentList/USER_COUNTERS_SET'
export const VIEWER_COUNTERS_SET = 'at/userProfile/cptAssignmentList/VIEWER_COUNTERS_SET'
export const PANEL_SEARCH_STRING_SET = 'at/userProfile/cptAssignmentList/PANEL_SEARCH_STRING_SET'
export const PANEL_SEARCH_OPEN_SET = 'at/userProfile/cptAssignmentList/PANEL_SEARCH_OPEN_SET'
export const NEED_TO_LOAD_DATA_SET = 'at/userProfile/cptAssignmentList/NEED_TO_LOAD_DATA_SET'

export const PANEL_OPEN = 'at/userProfile/cptAssignmentList/PANEL_OPEN'
export const PANEL_CLOSE = 'at/userProfile/cptAssignmentList/PANEL_CLOSE'
export const LOADING_SET = 'at/userProfile/cptAssignmentList/LOADING_SET'
export const LOADED_SET = 'at/userProfile/cptAssignmentList/LOADED_SET'

export const SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/cptAssignmentList/SET_IS_SHOW_ARCHIVE_ENTITIES'



// WEBPACK FOOTER //
// ./web/js/userProfile/cptAssignmentsList/actionTypes.js